import AdditionalObjectAttributes from './AdditionalObjectAttributes'

export default AdditionalObjectAttributes;